// extracted by mini-css-extract-plugin
export default {"container":"JobTimeslots_container__IA+1Q"};